export interface AddressLocality {
  key: string;
  name: string;
  nameZh: string;
}

export interface AddressDistrict {
  key: string;
  name: string;
  nameZh: string;
  localities: AddressLocality[];
}

export interface AddressRegion {
  key: string;
  name: string;
  nameZh: string;
  districts: AddressDistrict[];
}

export const hongKongAddressData: AddressRegion[] = [
  {
    key: "hong-kong-island",
    name: "Hong Kong Island",
    nameZh: "香港島",
    districts: [
      {
        key: "central-and-western",
        name: "Central and Western",
        nameZh: "中西區",
        localities: [
          { key: "central", name: "Central", nameZh: "中環" },
          { key: "admiralty", name: "Admiralty", nameZh: "金鐘" },
          { key: "sheung-wan", name: "Sheung Wan", nameZh: "上環" },
          { key: "sai-ying-pun", name: "Sai Ying Pun", nameZh: "西營盤" },
          { key: "kennedy-town", name: "Kennedy Town", nameZh: "堅尼地城" },
          { key: "mid-levels", name: "Mid-Levels", nameZh: "半山區" },
          { key: "the-peak", name: "The Peak", nameZh: "山頂" },
          { key: "pok-fu-lam", name: "Pok Fu Lam", nameZh: "薄扶林" }
        ]
      },
      {
        key: "eastern",
        name: "Eastern",
        nameZh: "東區",
        localities: [
          { key: "wan-chai", name: "Wan Chai", nameZh: "灣仔" },
          { key: "causeway-bay", name: "Causeway Bay", nameZh: "銅鑼灣" },
          { key: "happy-valley", name: "Happy Valley", nameZh: "跑馬地" },
          { key: "tai-hang", name: "Tai Hang", nameZh: "大坑" },
          { key: "tin-hau", name: "Tin Hau", nameZh: "天后" },
          { key: "north-point", name: "North Point", nameZh: "北角" },
          { key: "fortress-hill", name: "Fortress Hill", nameZh: "炮台山" },
          { key: "quarry-bay", name: "Quarry Bay", nameZh: "鰂魚涌" },
          { key: "tai-koo", name: "Tai Koo", nameZh: "太古" },
          { key: "sai-wan-ho", name: "Sai Wan Ho", nameZh: "西灣河" },
          { key: "shau-kei-wan", name: "Shau Kei Wan", nameZh: "筲箕灣" },
          { key: "heng-fa-chuen", name: "Heng Fa Chuen", nameZh: "杏花邨" },
          { key: "chai-wan", name: "Chai Wan", nameZh: "柴灣" }
        ]
      },
      {
        key: "southern",
        name: "Southern",
        nameZh: "南區",
        localities: [
          { key: "aberdeen", name: "Aberdeen", nameZh: "香港仔" },
          { key: "ap-lei-chau", name: "Ap Lei Chau", nameZh: "鴨脷洲" },
          { key: "wong-chuk-hang", name: "Wong Chuk Hang", nameZh: "黃竹坑" },
          { key: "tin-wan", name: "Tin Wan", nameZh: "田灣" },
          { key: "wah-fu", name: "Wah Fu", nameZh: "華富" },
          { key: "repulse-bay", name: "Repulse Bay", nameZh: "淺水灣" },
          { key: "stanley", name: "Stanley", nameZh: "赤柱" },
          { key: "tai-tam", name: "Tai Tam", nameZh: "大潭" },
          { key: "shek-o", name: "Shek O", nameZh: "石澳" }
        ]
      }
    ]
  },
  {
    key: "kowloon",
    name: "Kowloon",
    nameZh: "九龍",
    districts: [
      {
        key: "yau-tsim-mong",
        name: "Yau Tsim Mong",
        nameZh: "油尖旺區",
        localities: [
          { key: "tsim-sha-tsui", name: "Tsim Sha Tsui", nameZh: "尖沙咀" },
          { key: "tsim-sha-tsui-east", name: "Tsim Sha Tsui East", nameZh: "尖東" },
          { key: "jordan", name: "Jordan", nameZh: "佐敦" },
          { key: "yau-ma-tei", name: "Yau Ma Tei", nameZh: "油麻地" },
          { key: "mong-kok", name: "Mong Kok", nameZh: "旺角" },
          { key: "prince-edward", name: "Prince Edward", nameZh: "太子" },
          { key: "tai-kok-tsui", name: "Tai Kok Tsui", nameZh: "大角咀" }
        ]
      },
      {
        key: "sham-shui-po",
        name: "Sham Shui Po",
        nameZh: "深水埗區",
        localities: [
          { key: "sham-shui-po", name: "Sham Shui Po", nameZh: "深水埗" },
          { key: "cheung-sha-wan", name: "Cheung Sha Wan", nameZh: "長沙灣" },
          { key: "lai-chi-kok", name: "Lai Chi Kok", nameZh: "荔枝角" },
          { key: "mei-foo", name: "Mei Foo", nameZh: "美孚" },
          { key: "shek-kip-mei", name: "Shek Kip Mei", nameZh: "石硤尾" },
          { key: "so-uk", name: "So Uk", nameZh: "蘇屋" },
          { key: "un-chau", name: "Un Chau", nameZh: "元州" },
          { key: "nam-cheong", name: "Nam Cheong", nameZh: "南昌" },
          { key: "yau-yat-chuen", name: "Yau Yat Chuen", nameZh: "又一村" }
        ]
      },
      {
        key: "kowloon-city",
        name: "Kowloon City",
        nameZh: "九龍城區",
        localities: [
          { key: "hung-hom", name: "Hung Hom", nameZh: "紅磡" },
          { key: "to-kwa-wan", name: "To Kwa Wan", nameZh: "土瓜灣" },
          { key: "ma-tau-wai", name: "Ma Tau Wai", nameZh: "馬頭圍" },
          { key: "ma-tau-kok", name: "Ma Tau Kok", nameZh: "馬頭角" },
          { key: "kai-tak", name: "Kai Tak", nameZh: "啟德" },
          { key: "kowloon-city", name: "Kowloon City", nameZh: "九龍城" },
          { key: "kowloon-tong", name: "Kowloon Tong", nameZh: "九龍塘" },
          { key: "beacon-hill", name: "Beacon Hill", nameZh: "筆架山" },
          { key: "lok-fu", name: "Lok Fu", nameZh: "樂富" },
          { key: "wong-tai-sin", name: "Wong Tai Sin", nameZh: "黃大仙" },
          { key: "san-po-kong", name: "San Po Kong", nameZh: "新蒲崗" },
          { key: "tung-tau", name: "Tung Tau", nameZh: "東頭" },
          { key: "wang-tau-hom", name: "Wang Tau Hom", nameZh: "橫頭磡" },
          { key: "chuk-yuen", name: "Chuk Yuen", nameZh: "竹園" }
        ]
      },
      {
        key: "kwun-tong",
        name: "Kwun Tong",
        nameZh: "觀塘區",
        localities: [
          { key: "kwun-tong", name: "Kwun Tong", nameZh: "觀塘" },
          { key: "ngau-tau-kok", name: "Ngau Tau Kok", nameZh: "牛頭角" },
          { key: "kowloon-bay", name: "Kowloon Bay", nameZh: "九龍灣" },
          { key: "choi-hung", name: "Choi Hung", nameZh: "彩虹" },
          { key: "diamond-hill", name: "Diamond Hill", nameZh: "鑽石山" },
          { key: "ping-shek", name: "Ping Shek", nameZh: "坪石" },
          { key: "san-po-kong-2", name: "San Po Kong", nameZh: "新蒲崗" },
          { key: "sau-mau-ping", name: "Sau Mau Ping", nameZh: "秀茂坪" },
          { key: "lam-tin", name: "Lam Tin", nameZh: "藍田" },
          { key: "yau-tong", name: "Yau Tong", nameZh: "油塘" },
          { key: "lei-yue-mun", name: "Lei Yue Mun", nameZh: "鯉魚門" }
        ]
      }
    ]
  },
  {
    key: "new-territories",
    name: "New Territories",
    nameZh: "新界",
    districts: [
      {
        key: "kwai-tsing",
        name: "Kwai Tsing",
        nameZh: "葵青區",
        localities: [
          { key: "kwai-chung", name: "Kwai Chung", nameZh: "葵涌" },
          { key: "kwai-fong", name: "Kwai Fong", nameZh: "葵芳" },
          { key: "kwai-hing", name: "Kwai Hing", nameZh: "葵興" },
          { key: "tai-wo-hau", name: "Tai Wo Hau", nameZh: "大窩口" },
          { key: "tsing-yi", name: "Tsing Yi", nameZh: "青衣" }
        ]
      },
      {
        key: "tsuen-wan",
        name: "Tsuen Wan",
        nameZh: "荃灣區",
        localities: [
          { key: "tsuen-wan", name: "Tsuen Wan", nameZh: "荃灣" },
          { key: "tsuen-wan-west", name: "Tsuen Wan West", nameZh: "荃灣西" },
          { key: "tai-wo-hau-2", name: "Tai Wo Hau", nameZh: "大窩口" },
          { key: "shek-wai-kok", name: "Shek Wai Kok", nameZh: "石圍角" },
          { key: "lei-muk-shue", name: "Lei Muk Shue", nameZh: "梨木樹" },
          { key: "ting-kau", name: "Ting Kau", nameZh: "汀九" },
          { key: "sham-tseng", name: "Sham Tseng", nameZh: "深井" }
        ]
      },
      {
        key: "tuen-mun",
        name: "Tuen Mun",
        nameZh: "屯門區",
        localities: [
          { key: "tuen-mun", name: "Tuen Mun", nameZh: "屯門" },
          { key: "tai-lam", name: "Tai Lam", nameZh: "大欖" },
          { key: "so-kwun-wat", name: "So Kwun Wat", nameZh: "掃管笏" },
          { key: "siu-lam", name: "Siu Lam", nameZh: "小欖" },
          { key: "butterfly-beach", name: "Butterfly Beach", nameZh: "蝴蝶灣" },
          { key: "gold-coast", name: "Gold Coast", nameZh: "黃金海岸" },
          { key: "castle-peak-bay", name: "Castle Peak Bay", nameZh: "青山灣" }
        ]
      },
      {
        key: "yuen-long",
        name: "Yuen Long",
        nameZh: "元朗區",
        localities: [
          { key: "yuen-long", name: "Yuen Long", nameZh: "元朗" },
          { key: "tin-shui-wai", name: "Tin Shui Wai", nameZh: "天水圍" },
          { key: "hung-shui-kiu", name: "Hung Shui Kiu", nameZh: "洪水橋" },
          { key: "ping-shan", name: "Ping Shan", nameZh: "屏山" },
          { key: "ha-tsuen", name: "Ha Tsuen", nameZh: "廈村" },
          { key: "lau-fau-shan", name: "Lau Fau Shan", nameZh: "流浮山" },
          { key: "kam-tin", name: "Kam Tin", nameZh: "錦田" },
          { key: "pat-heung", name: "Pat Heung", nameZh: "八鄉" },
          { key: "shap-pat-heung", name: "Shap Pat Heung", nameZh: "十八鄉" },
          { key: "san-tin", name: "San Tin", nameZh: "新田" },
          { key: "lok-ma-chau", name: "Lok Ma Chau", nameZh: "落馬洲" },
          { key: "fairview-park", name: "Fairview Park", nameZh: "錦繡花園" },
          { key: "palm-springs", name: "Palm Springs", nameZh: "加州花園" },
          { key: "yoho-town", name: "Yoho Town", nameZh: "Yoho Town" }
        ]
      },
      {
        key: "north",
        name: "North",
        nameZh: "北區",
        localities: [
          { key: "sheung-shui", name: "Sheung Shui", nameZh: "上水" },
          { key: "fanling", name: "Fanling", nameZh: "粉嶺" },
          { key: "luen-wo-hui", name: "Luen Wo Hui", nameZh: "聯和墟" },
          { key: "shek-wu-hui", name: "Shek Wu Hui", nameZh: "石湖墟" },
          { key: "tai-po", name: "Tai Po", nameZh: "大埔" },
          { key: "tai-po-market", name: "Tai Po Market", nameZh: "大埔墟" },
          { key: "tai-wo", name: "Tai Wo", nameZh: "太和" },
          { key: "lam-tsuen", name: "Lam Tsuen", nameZh: "林村" }
        ]
      },
      {
        key: "sha-tin",
        name: "Sha Tin",
        nameZh: "沙田區",
        localities: [
          { key: "sha-tin", name: "Sha Tin", nameZh: "沙田" },
          { key: "tai-wai", name: "Tai Wai", nameZh: "大圍" },
          { key: "fo-tan", name: "Fo Tan", nameZh: "火炭" },
          { key: "ma-on-shan", name: "Ma On Shan", nameZh: "馬鞍山" },
          { key: "wu-kai-sha", name: "Wu Kai Sha", nameZh: "烏溪沙" },
          { key: "shek-mun", name: "Shek Mun", nameZh: "石門" },
          { key: "city-one", name: "City One", nameZh: "第一城" },
          { key: "tai-shui-hang", name: "Tai Shui Hang", nameZh: "大水坑" },
          { key: "heng-on", name: "Heng On", nameZh: "恆安" }
        ]
      },
      {
        key: "sai-kung",
        name: "Sai Kung",
        nameZh: "西貢區",
        localities: [
          { key: "sai-kung", name: "Sai Kung", nameZh: "西貢" },
          { key: "clear-water-bay", name: "Clear Water Bay", nameZh: "清水灣" },
          { key: "tseung-kwan-o", name: "Tseung Kwan O", nameZh: "將軍澳" },
          { key: "hang-hau", name: "Hang Hau", nameZh: "坑口" },
          { key: "po-lam", name: "Po Lam", nameZh: "寶林" },
          { key: "lohas-park", name: "LOHAS Park", nameZh: "日出康城" },
          { key: "tiu-keng-leng", name: "Tiu Keng Leng", nameZh: "調景嶺" }
        ]
      },
      {
        key: "islands",
        name: "Islands",
        nameZh: "離島區",
        localities: [
          { key: "lantau-island", name: "Lantau Island", nameZh: "大嶼山" },
          { key: "tung-chung", name: "Tung Chung", nameZh: "東涌" },
          { key: "discovery-bay", name: "Discovery Bay", nameZh: "愉景灣" },
          { key: "mui-wo", name: "Mui Wo", nameZh: "梅窩" },
          { key: "tai-o", name: "Tai O", nameZh: "大澳" },
          { key: "ngong-ping", name: "Ngong Ping", nameZh: "昂坪" },
          { key: "peng-chau", name: "Peng Chau", nameZh: "坪洲" },
          { key: "lamma-island", name: "Lamma Island", nameZh: "南丫島" },
          { key: "cheung-chau", name: "Cheung Chau", nameZh: "長洲" }
        ]
      }
    ]
  }
];

export const getLocalizedAddressData = (language: string): AddressRegion[] => {
  if (language === 'zh-TW' || language === 'zh-CN' || language === 'zh') {
    const isSimplified = language === 'zh-CN';
    let converter: ((text: string) => string) | null = null;

    if (isSimplified) {
      // Dynamic import to avoid issues if OpenCC is not available
      try {
        const OpenCC = require('opencc-js');
        converter = OpenCC.Converter({ from: 'tw', to: 'cn' });
      } catch {
        // If OpenCC is not available, fall back to Traditional Chinese
        converter = null;
      }
    }

    return hongKongAddressData.map(region => ({
      ...region,
      name: converter ? converter(region.nameZh) : region.nameZh,
      districts: region.districts.map(district => ({
        ...district,
        name: converter ? converter(district.nameZh) : district.nameZh,
        localities: district.localities.map(locality => ({
          ...locality,
          name: converter ? converter(locality.nameZh) : locality.nameZh
        }))
      }))
    }));
  }
  return hongKongAddressData;
};

export const findAddressParts = (city?: string, state?: string) => {
  if (!city || !state) return { region: null, district: null, locality: null };
  
  for (const region of hongKongAddressData) {
    for (const district of region.districts) {
      const locality = district.localities.find(
        loc => loc.name === city || loc.nameZh === city || loc.key === city
      );
      if (locality && (district.name === state || district.nameZh === state || district.key === state)) {
        return { region, district, locality };
      }
    }
  }
  
  return { region: null, district: null, locality: null };
};

export const findAddressPartsByKeys = (regionKey?: string, districtKey?: string, localityKey?: string) => {
  if (!regionKey || !districtKey || !localityKey) return { region: null, district: null, locality: null };
  
  const region = hongKongAddressData.find(r => r.key === regionKey);
  if (!region) return { region: null, district: null, locality: null };
  
  const district = region.districts.find(d => d.key === districtKey);
  if (!district) return { region: null, district: null, locality: null };
  
  const locality = district.localities.find(l => l.key === localityKey);
  if (!locality) return { region: null, district: null, locality: null };
  
  return { region, district, locality };
};

export const getAddressNameByKey = (key: string, language: string = 'en'): string => {
  const isChineseLanguage = language === 'zh-TW' || language === 'zh-CN' || language === 'zh';
  const isSimplified = language === 'zh-CN';
  let converter: ((text: string) => string) | null = null;

  if (isSimplified) {
    try {
      const OpenCC = require('opencc-js');
      converter = OpenCC.Converter({ from: 'tw', to: 'cn' });
    } catch {
      converter = null;
    }
  }

  // Search through all regions, districts, and localities
  for (const region of hongKongAddressData) {
    if (region.key === key) {
      if (!isChineseLanguage) return region.name;
      return converter ? converter(region.nameZh) : region.nameZh;
    }

    for (const district of region.districts) {
      if (district.key === key) {
        if (!isChineseLanguage) return district.name;
        return converter ? converter(district.nameZh) : district.nameZh;
      }

      for (const locality of district.localities) {
        if (locality.key === key) {
          if (!isChineseLanguage) return locality.name;
          return converter ? converter(locality.nameZh) : locality.nameZh;
        }
      }
    }
  }

  return key; // Return the key if no match found
};